import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              迷妹漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(1, 6).map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 pl-9 pr-3 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl w-5 h-5 flex items-center justify-center ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 shadow-lg">
          <div className="px-4 py-3">
            <div className="relative mb-3">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-3 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-400"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <div className="flex flex-col gap-1">
              <Link to="/" className="px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap">首页</Link>
              {categories.map(cat => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}